import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useInvalidateCache } from "~hooks/useInvalidateCache.ts";
import { useUpdatePermissionScopeCache } from "~hooks/useUpdatePermissionScopeCache.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useDeleteLeague = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();
  const { mutateAsync: invalidateCache } = useInvalidateCache();
  const updatePermissionScopeCache = useUpdatePermissionScopeCache();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (leagueId: string) => {
      const url = `${sport}/o/${organizationId}/leagues/${leagueId}`;
      return await request(url, {
        method: "DELETE",
      });
    },
    onSuccess: async (response, leagueId) => {
      const operationResult = response?.data?.[0];

      if (!operationResult?.success) {
        return;
      }

      updatePermissionScopeCache(sport, organizationId, (updatedScope) => {
        updatedScope.scope.leagueTree = updatedScope.scope.leagueTree.filter(({ leagueId: id }) => id !== leagueId);

        if (updatedScope.resources?.leagues?.[leagueId]) {
          delete updatedScope.resources.leagues[leagueId];
        }
      });

      await Promise.all([invalidateCache(), queryClient.invalidateQueries({ queryKey: ["leagues", sport, organizationId] })]);
    },
  });
};
